$(document).on(
  "click",
  ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question",
  function (e) {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).toggleClass("active");
      jQuery(this).next().slideToggle();
    } else {
      jQuery(
        ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question"
      ).removeClass("active");
      jQuery(
        ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question"
      )
        .next()
        .slideUp();
      jQuery(this).toggleClass("active");
      jQuery(this).next().slideToggle();
    }
  }
);
$(document).on("click", ".custom_button", function (e) {
  var video = jQuery(this).parents(".video_wrapper_custom").find("video");
  if (jQuery(this).hasClass("active")) {
    jQuery(this).parents(".video_wrapper_custom").removeClass("video-active");
    jQuery(this).removeClass("active");
    video.trigger("pause");
  } else {
    video.trigger("play");
    jQuery(this).parents(".video_wrapper_custom").addClass("video-active");
    jQuery(this).addClass("active");
  }
});

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

$(window).scroll(function () {
  $(".numbers_section_lp .icons_with_text_flex").each(function () {
    var this_element = $(this);
    if (this_element.hasClass("start_count")) {
    } else {
      if (isScrolledIntoView(this) === true) {
        this_element.addClass("start_count");
        $(".count_js").each(function () {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).data("value"),
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $(this).text(Math.ceil(now));
                },
              }
            );
        });
      }
    }
  });
});

$(document).on("click", "a[href='#formula']", function (e) {
  e.preventDefault();
  document.querySelector("#formula").scrollIntoView({
    behavior: "smooth",
  });
});

$(document).on("click", "a[href='#science']", function (e) {
  e.preventDefault();
  document.querySelector("#science").scrollIntoView({
    behavior: "smooth",
  });
});

$(document).on("click", "a[href='#gummies']", function (e) {
  e.preventDefault();
  document.querySelector("#gummies").scrollIntoView({
    behavior: "smooth",
  });
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector("#gummies").scrollIntoView({
    behavior: "smooth",
  });
});

$(document).on("click", ".custom_cart_icon_menu", function (e) {
  e.preventDefault();
  $(".menu-drawer__close-btn").trigger("click");
  jQuery("cart-drawer").removeClass("is-empty").addClass("active");
  jQuery("body ").addClass("overflow-hidden");
});
